var _a, _b, _c, _d, _e, _f, _g, _h;
import AppEnvironmentEnum from "../@types/enums/AppEnvironmentEnum";
if (!window.onnit_context) {
    throw new Error("`window.onnit_context` is undefined.");
}
var environment = window.onnit_context.environment;
var APP_ENV_IS_PROD = environment === AppEnvironmentEnum.PRODUCTION;
var FREE_SHIPPING_THRESHOLD_DEFAULT = window.onnit_context.disruptive_sale.is_black_friday_cyber_monday ? 100 : 150;
export default Object.freeze({
    ALLIT_URL: window.onnit_context.url.allit,
    API_URL: window.onnit_context.url.api,
    APP_ENV: window.onnit_context.environment,
    APP_ENV_IS_PROD: APP_ENV_IS_PROD,
    CUSTOMER_ID_COOKIE: "ONNIT_CUSTOMER_ID",
    GOOGLE_MAPS_API_KEY: (_b = (_a = window.onnit_context) === null || _a === void 0 ? void 0 : _a.api_key) === null || _b === void 0 ? void 0 : _b.google_maps,
    GOOGLE_MAPS_SDK_URL: "https://maps.googleapis.com/maps/api/js",
    NODE_ENV: process.env.NODE_ENV,
    ONNIT_FAVORITES: "ONNIT_FAVORITES",
    RECAPTCHA_PUBLIC_KEY: (_d = (_c = window.onnit_context) === null || _c === void 0 ? void 0 : _c.api_key) === null || _d === void 0 ? void 0 : _d.recaptcha_public_key,
    PERSONALIZE_API_URL: (_f = (_e = window.onnit_context) === null || _e === void 0 ? void 0 : _e.personalize) === null || _f === void 0 ? void 0 : _f.api_url,
    PERSONALIZE_API_KEY: (_h = (_g = window.onnit_context) === null || _g === void 0 ? void 0 : _g.personalize) === null || _h === void 0 ? void 0 : _h.api_key,
    FREE_SHIPPING_THRESHOLD_DEFAULT: FREE_SHIPPING_THRESHOLD_DEFAULT,
    PAYPAL_CLIENT_ID: APP_ENV_IS_PROD
        ? "AQtuFVUYYqU6JK53wbCHr4Ae7nQ30czGSa3ok8yPoR76CEikBWcubMHOTNzyUdGGKoRBqBJD0IYrkxbl"
        : "AabpF245ilNDNXNvurIzj1_tzFqFx_TXti3VXjzcOS79m32tWmNNo6UbM8fYo-oAyVPa1q2ub35c4efK",
});
//# sourceMappingURL=index.js.map